module.exports = __webpack_public_path__ + "img/iran-zamin.8d3cdfff.png";